import DebugModal from './DebugModal'
import ConfigDebugView from './views/ConfigDebugView'

export default function ConfigDebugModal() {
  return (
    <DebugModal debugKey="config" label="Config">
      <ConfigDebugView />
    </DebugModal>
  )
}
